import { DocsBlockPropertyDefinition, } from "./SDKDocsBlockProperty";
/** SingleSelect property - Definition */
export class DocsBlockSingleSelectPropertyDefinition extends DocsBlockPropertyDefinition {
}
